import { render, staticRenderFns } from "./EmployerTasks.vue?vue&type=template&id=1c53b0a1&scoped=true&lang=pug"
import script from "./EmployerTasks.vue?vue&type=script&lang=ts"
export * from "./EmployerTasks.vue?vue&type=script&lang=ts"
import style0 from "./EmployerTasks.vue?vue&type=style&index=0&id=1c53b0a1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53b0a1",
  null
  
)

/* custom blocks */
import block0 from "./REmployerCandidateTasks.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FWidgets%2FTasks%2FEmployerTasks.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports